




















import Vue from 'vue'
import Component from 'vue-class-component';
import pdf from 'vue-pdf';

@Component({
    components: {
        pdf
    }
})
export default class PrivacyStatement extends Vue {
    mounted() {
        this.pdf.promise.then((pdf: any) => {
            this.numPages = pdf.numPages;
        });
    }

    get baseUrl(): string {
        return process.env.BASE_URL;
    }
    
    numPages = 0;

    pdf = pdf.createLoadingTask(`${this.baseUrl}detox_privacy.pdf`);
}
